import React from "react";
import ButtonSelect from "./ButtonSelect.js";

interface ButtonOnFieldPlayerViewProps {
  selectedView?: string;
  selectedAttribute?: string;
  onChange?: func;
  onAttributeChange?: func;
}

const ButtonOnFieldPlayerView: React.FC<ButtonOnFieldPlayerViewProps> = ({
  selectedView,
  selectedAttribute,
  onChange,
  onAttributeChange,
  hideDepth
}) => {
  return (
    <div className="d-flex flex-column align-items-end">
      <ButtonSelect
        className="d-flex flex-row ms-md-2 border light-background-color"
        style={{ width: "fit-content" }}
        buttons={{ ovr: "OVRs", attr: "Attr.", profile: "Profile", ...(!hideDepth ? { depth: "Depth" } : {}) }}
        selected={selectedView || "ovr"}
        onChange={onChange}
        selectedClassName="btn-info text-white"
      />
    </div>
  );
};

export default ButtonOnFieldPlayerView;
